export default __webpack_public_path__ + "static/media/007-star-blue.be7c2eeb.svg";